import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {OneMonthFreeMode} from "../../one-month-free.component";
import {UserSubscription} from "../../../../../../user/user-subscription";

@Component({
    selector: 'db-one-month-free-payment-steps',
    templateUrl: './one-month-free-payment-steps.component.html',
    styleUrls: ['./one-month-free-payment-steps.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OneMonthFreePaymentStepsComponent implements OnInit {

  @Input() mode: OneMonthFreeMode;
  @Input() expirationDate: string;
  @Input() currentSubscription: UserSubscription;
  public notisDate: number;

  ngOnInit() {
    const d = new Date();
    this.notisDate = d.setDate(new Date().getDate() + 6);
  }

}
